/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Product with image
 * @export
 * @interface SurfaceProduct
 */
export interface SurfaceProduct {
    /**
     * 
     * @type {string}
     * @memberof SurfaceProduct
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceProduct
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceProduct
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the SurfaceProduct interface.
 */
export function instanceOfSurfaceProduct(value: object): value is SurfaceProduct {
    return true;
}

export function SurfaceProductFromJSON(json: any): SurfaceProduct {
    return SurfaceProductFromJSONTyped(json, false);
}

export function SurfaceProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function SurfaceProductToJSON(json: any): SurfaceProduct {
    return SurfaceProductToJSONTyped(json, false);
}

export function SurfaceProductToJSONTyped(value?: SurfaceProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'imageId': value['imageId'],
        'imageUrl': value['imageUrl'],
    };
}

